import { render } from "./Message.vue?vue&type=template&id=3cdf87bb"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=3cdf87bb&lang=css"
script.render = render

export default script